import { ui } from "@/components/ui";
import { ChevronsUpDown, Trash2, User2 } from "lucide-react";
import _ from "underscore";
import SelectStaffForm from "./SelectStaffForm";

import type { StatefulDiaryT } from "@/types/database/diaries";
import { Link } from "@tanstack/react-router";
import { useDeleteDiaryAccess } from "../api/deleteDiaryAccess";

interface Props {
	diary: StatefulDiaryT;
}

const ShareDiaryDialog = ({ diary }: Props) => {
	const { mutate: deleteDiaryAccess, isPending } = useDeleteDiaryAccess();
	return (
		<ui.DialogContent className="max-w-md">
			<ui.DialogHeader>
				<ui.DialogTitle>Share Diary</ui.DialogTitle>
			</ui.DialogHeader>

			<p className="dark:text-slate-200 text-sm">
				Can't see the user?{" "}
				<span>
					<Link className="link" to="/invite">
						Invite them
					</Link>
				</span>{" "}
				then share the diary.
			</p>
			<hr className="" />

			<SelectStaffForm diaryId={diary.diary_id} />

			<ui.Collapsible defaultOpen={true}>
				<ui.CollapsibleTrigger className="flex flex-row justify-between items-center w-full text-md text-slate-700">
					Shared With
					<ui.Button
						tabIndex={-1}
						size="icon"
						variant="ghost"
						type="button"
						className=""
					>
						<ChevronsUpDown />
					</ui.Button>
				</ui.CollapsibleTrigger>
				{_.unique(diary?.diary_access as any[])
					?.filter((da) => da.capacity === "direct_access")
					?.map((user) => (
						<ui.CollapsibleContent
							key={user.user_id}
							className="flex items-center gap-2 pl-2 border-slate-300 not-last:border-b w-full text-md text-slate-800"
						>
							<div className="flex items-center gap-2 w-full">
								<User2 />
								{user.name}
							</div>
							<ui.Button
								size="icon"
								variant="ghost"
								type="button"
								disabled={isPending}
								onClick={() =>
									deleteDiaryAccess({
										diary_id: diary.diary_id,
										user_id: user.user_id,
									})}
							>
								<Trash2 size={20} />
							</ui.Button>
						</ui.CollapsibleContent>
					))}
			</ui.Collapsible>
		</ui.DialogContent>
	);
};

export default ShareDiaryDialog;
